<template>
  <div class="inner_white">
    <div class="filter">
      <div class="field_left">
        <search-input input-class="search" v-model="formFields.search"></search-input>
      </div>
      <div class="field_right" v-if="isVideoList">
        <select-box
            id="vodprovider"
            :options="vodProviderOptions"
            v-model="formFields.id_vod_provider"
            ref="ivodproviderref"
        >
          <translate class="translate">Poskytovatel videa</translate>
        </select-box>
      </div>
      <div class="field_left" v-if="isVideoList">
        <select-box
            id="maturity_rating"
            :options="maturityRatingOptions"
            v-model="formFields.id_maturity_rating"
            ref="ivodproviderref"
        >
          <translate class="translate">Věkové omezení</translate>
        </select-box>
      </div>
      <div class="field_right" v-if="isVideoList || isProviderVideoList">
        <select-box
            id="vodpackage"
            :options="vodPackageOptions"
            v-model="formFields.id_vod_package"
            ref="ivodpackageref"
        >
          <translate class="translate">Balíček videí</translate>
        </select-box>
      </div>
      <div class="field_left">
        <date-picker
            id="provided_from"
            attrKey="provided_from"
            date-format="d. m. yy"
            v-model="formFields.provided_from"
            @update-date="updateFormDate"
        >
          <translate class="translate">Poskytováno od</translate>
        </date-picker>
      </div>
      <div class="field_right">
        <date-picker
            id="provided_to"
            attrKey="provided_to"
            date-format="d. m. yy"
            v-model="formFields.provided_to"
            @update-date="updateFormDate"
        >
          <translate class="translate">Poskytováno do</translate>
        </date-picker>
      </div>
      <div class="field_left">
        <select-box
            id="idtags"
            :options="tagOptions"
            v-model="formFields.id_tag"
            ref="ivodpackageref"
        >
          <translate class="translate">Štítky videa</translate>
        </select-box>
      </div>
      <div class="field_right">
        <select-box
            id="idcountries"
            :options="countryOptions"
            v-model="formFields.id_country"
            ref="ivodproviderref"
        >
          <translate class="translate">Státy</translate>
        </select-box>
      </div>
      <div class="field_left">
        <select-box
            id="type"
            :options="typeOptions"
            v-model="formFields.type"
            ref="typeref"
        >
          <translate class="translate">Typ</translate>
        </select-box>
      </div>
      <div class="field_right">
        <select-box
            id="sourcestate"
            :options="sourceStateOptions"
            v-model="formFields.source_state"
            ref="stateref"
        >
          <translate class="translate">Stav zpracování zdroje</translate>
        </select-box>
      </div>
      <div class="field_left">
        <p class="field checkbox_label"></p>
        <div class="field checkboxes">
          <filter-checkbox
              key="group_by_series"
              id="group_by_series"
              name="group_by_series"
              v-model="formFields.group_by_series">
            <translate class="translate">Slučovat epizody sérii</translate>
          </filter-checkbox>
        </div>
      </div>
      <div class="field_right">
        <select-box
            id="localstate"
            :options="localStateOptions"
            v-model="formFields.local_state"
            ref="stateref"
        >
          <translate class="translate">Stav lokálního zpracování</translate>
        </select-box>
      </div>
      <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
         :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
    </div>

    <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="vod-videos-list">
        <table class="vypis vypis_detail">
          <thead>
          <tr v-if="entities.length > 0">
            <th class="no_padding drag_drop"/>
            <th class="no_padding checkbox"/>
            <sorting-table-title
                v-for="title in tableTitles"
                :key="title.key"
                :column="title.column"
                :sortable="title.sortable"
                :sort="getActiveSort(title.column)"
                @changeSorting="changeSorting"
            >{{ title.name }}
            </sorting-table-title>
            <th class="no_padding edit"/>
          </tr>
          </thead>

          <vod-videos-row
              v-for="entity in entities"
              :entity="entity"
              :group-by-series="formFields.group_by_series"
              :tags="tagsById"
              :countries="countriesById"
              :key="entity.id"
              @input="select"
              :selectedEntities="selectedEntities"
              :ref="'vod-videos-row-ref-'+entity.id"
          ></vod-videos-row>

          <tr v-if="entities.length === 0">
            <td colspan="4">{{ $gettext('Nebyla nalezena žádná videa.') }}</td>
          </tr>
        </table>
      </div>
    </div>
    <list-action-line
        :entities="entities"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        :offset="formFields.offset"
        :limit="formFields.limit"
        :total-count="totalCount"
        table-id="vod-videos-list"
        @run-multiple-action="runMultipleAction"
        @limit="setLimit"
        @offset="setOffset"
        @select-all="toggleSelectAll"
        ref="action_line"
    ></list-action-line>
  </div>
</template>

<script>
import VodVideosRow from "./VodVideosRow.vue";
import listActions from "@/components/mixins/list-actions"
import vodVideo from "./mixins/vodVideo";
import {iso6391ToIso6392, prependOptions} from "../../../utils/helpers";

export default {
  name: "VodVideos",
  components: {
    VodVideosRow,
  },
  mixins: [listActions, vodVideo],
  data() {
    return {
      moduleName: 'vodVideos',
      entitiesKey: 'vodVideos',
      dateFields: ['provided_from', 'provided_to'],
      formFields: {
        id_vod_provider: 0,
        id_vod_package: 0,
        group_by_series: false,
        id_tag: 0,
        id_country: 0,
        id_maturity_rating: 0,
        type: 0,
        source_state: 0,
        local_state: 0,
        provided_from: null,
        provided_to: null,
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
      skipEvent: true,
      vodProviderList: [],
      vodPackageList: [],
      maturityRatingList: [],
      tagList: [],
      countryList: [],
    }
  },
  created(VodVideoService, VodProviderService, VodPackageService, MaturityRatingService, EpgCacheService) {
    this.entityService = VodVideoService;
    this.vodProviderService = VodProviderService;
    this.vodPackageService = VodPackageService;
    this.maturityRatingService = MaturityRatingService;
    this.epgCacheService = EpgCacheService;

    let formDefaultData = this.getDefaults();
    formDefaultData = this._beforeGetEntitiesProcess(formDefaultData);
    formDefaultData = this.mergeDefaultValues(formDefaultData);

    this.getMaturityRatingList();
    this.getTagList();
    this.getCountryList();
    this.getVodProviderList()
        .then(() => {
      this.getVodPackageList(formDefaultData.id_vod_provider)
          .then(() => {
            this.formFields = formDefaultData;
          })
    })
  },
  computed: {
    isVideoList(){
      return this.$route.name === 'vodVideos';
    },
    isProviderVideoList(){
      return this.$route.name === 'vodProvidersVideos';
    },
    tableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Série a epizoda'), column: 'sSeasonAndEpisode'},
        {key: 3, name: this.$gettext('Věkové omezení'), column: 'sMaturityRating'},
        {key: 4, name: this.$gettext('Štítky'), column: 'sMaturityRating', sortable: false},
        {key: 5, name: this.$gettext('Státy'), column: 'sMaturityRating', sortable: false},
        {key: 6, name: this.$gettext('Poskytovatel videa'), column: 'sVodProviderName'},
        {key: 7, name: this.$gettext('Balíčky'), column: 'sPackages', sortable: false},
        {key: 8, name: this.$gettext('Stav zpracování na zdroji'), column: 'sSourceState'},
        {key: 9, name: this.$gettext('Stav lokálního zpracování'), column: 'sLocalState'},
        {key: 10, name: this.$gettext('Délka'), column: 'sDurationSeconds'},
        {key: 11, name: this.$gettext('Poskytováno od'), column: 'sProvidedFrom'},
        {key: 12, name: this.$gettext('Poskytováno do'), column: 'sProvidedTo'},
      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    tagsById(){
      let tags = {};
      this.tagOptions.forEach((item) => {
        tags[item.id] = item.text;
      });

      return tags;
    },
    countriesById(){
      let countries = {};
      this.countryOptions.forEach((item) => {
        countries[item.id] = item.text;
      });

      return countries;
    },
    typeOptions(){
      return [
        {id: 0, text: this.$gettext('Všechny')},
        {id: 'serial', text: this.$gettext('Pouze seriály')},
        {id: 'movie', text: this.$gettext('Pouze filmy')},
      ]
    },
    sourceStateOptions(){
      return [
        {id: 0, text: this.$gettext('Všechny')},
        {id: 'READY', text: this.getSourceStateText('READY')},
        {id: 'WAITING', text: this.getSourceStateText('WAITING')},
        {id: 'FAILED', text: this.getSourceStateText('FAILED')},
      ]
    },
    localStateOptions(){
      return [
        {id: 0, text: this.$gettext('Všechny')},
        {id: 'IMPORTED', text: this.getLocalStateText('IMPORTED')},
        {id: 'PENDING', text: this.getLocalStateText('PENDING')},
        {id: 'UNUSED', text: this.getLocalStateText('UNUSED')},
        {id: 'FAILED', text: this.getLocalStateText('FAILED')},
      ]
    },
    vodProviderOptions(){
      if(this.vodProviderList){
        return prependOptions([...this.vodProviderList], this.$gettext('Všechny'));
      }else{
        return [];
      }
    },
    vodPackageOptions(){
      if(this.vodPackageList){
        return prependOptions([...this.vodPackageList], this.$gettext('Všechny'));
      }else{
        return [];
      }
    },
    maturityRatingOptions(){
      if(this.maturityRatingList){
        return prependOptions([...this.maturityRatingList], this.$gettext('Všechny'));
      }else{
        return [];
      }
    },
    tagOptions(){
      if(this.tagList){
        return prependOptions([...this.tagList], this.$gettext('Všechny'));
      }else{
        return [];
      }
    },
    countryOptions(){
      if(this.countryList){
        return prependOptions([...this.countryList], this.$gettext('Všechny'));
      }else{
        return [];
      }
    },
  },
  methods: {
    _beforeGetEntitiesProcess(formFields) {
      if(!this.isVideoList){
        if(this.$route.name === 'vodPackagesVideos'){
          formFields.id_vod_package = this.$route.params['id'];
          formFields.id_vod_provider = 0;
        }else if(this.$route.name === 'vodProvidersVideos'){
          formFields.id_vod_provider = this.$route.params['id'];
        }
      }else{
        formFields.id_vod_provider = this.getDefaultValue('id_vod_provider') || 0;
        formFields.id_vod_package = this.getDefaultValue('id_vod_package') || 0;
      }

      return formFields;
    },
    getVodProviderList(){
      return this.vodProviderService.getSimpleList({id_operator: this.$_loggedUser_selectedOperatorId})
          .then((data) => {
            this.vodProviderList = data['vodProviders'];
          });
    },
    getVodPackageList(defaultIdVodProvider){
      return this.vodPackageService.getSimpleList({id_vod_provider: defaultIdVodProvider || this.formFields.id_vod_provider, id_operator: this.$_loggedUser_selectedOperatorId})
          .then((data) => {
            this.vodPackageList = data['vodPackages'];
          });
    },
    getMaturityRatingList(){
      this.maturityRatingService.getSimpleList({show_all_ages_item: false})
          .then((data) => {
            this.maturityRatingList = data['maturity_ratings'];
          });
    },
    getTagList(){
      this.epgCacheService.getTagsSimpleList({lng_priority: iso6391ToIso6392(this.$store.getters.getLanguage)})
          .then((data) => {
            this.tagList = data['tags'];
          });
    },
    getCountryList(){
      this.epgCacheService.getCountriesSimpleList({lng_priority: iso6391ToIso6392(this.$store.getters.getLanguage)})
          .then((data) => {
            this.countryList = data['countries'];
          });
    },
    getDefaults() {
      const loadedData = {};
      loadedData.search = this.getDefaultValue('search');
      loadedData.group_by_series = this.getDefaultValue('group_by_series');
      loadedData.provided_from = this.getDefaultValue('provided_from');
      loadedData.provided_to = this.getDefaultValue('provided_to');
      loadedData.id_tag = this.getDefaultValue('id_tag');
      loadedData.id_country = this.getDefaultValue('id_country');
      loadedData.id_maturity_rating = this.getDefaultValue('id_maturity_rating');
      loadedData.type = this.getDefaultValue('type');
      loadedData.source_state = this.getDefaultValue('source_state');
      loadedData.local_state = this.getDefaultValue('local_state');

      return loadedData;
    },

    saveFilterValues(){
      this.saveSearch(this.formFields.search)
      this.setUserSetting('id_vod_provider', this.formFields.id_vod_provider);
      this.setUserSetting('group_by_series', this.formFields.group_by_series);
      this.setUserSetting('provided_from', this.formFields.provided_from);
      this.setUserSetting('provided_to', this.formFields.provided_to);
      this.setUserSetting('id_vod_package', this.formFields.id_vod_package);
      this.setUserSetting('id_tag', this.formFields.id_tag);
      this.setUserSetting('id_country', this.formFields.id_country);
      this.setUserSetting('id_maturity_rating', this.formFields.id_maturity_rating);
      this.setUserSetting('type', this.formFields.type);
      this.setUserSetting('source_state', this.formFields.source_state);
      this.setUserSetting('local_state', this.formFields.local_state);
    },
    updateFormDate(dateInfo) {
      this.formFields[dateInfo.attrKey] = dateInfo.date
    },
    getDefaultValue(key){
      let data = {module: this.moduleName, key: key}
      if (this.$store.getters.hasSetting(data)){
        return this.$store.getters.getSetting(data)
      }else{
        return null;
      }
    },
    mergeDefaultValues(loadedData){
      return Object.fromEntries(
          Object.keys(this.formFields).map(key => [
            key,
            loadedData[key] !== null && loadedData[key] !== undefined ? loadedData[key] : this.formFields[key]
          ])
      )
    }
  },
  watch: {
    $_loggedUser_selectedOperatorId(){
      this.formFields.id_vod_provider = 0;
      this.setUserSetting('id_vod_provider', this.formFields.id_vod_provider);
      this.getVodProviderList();
    },
    'formFields.group_by_series'(){
      if(!this.formFields.group_by_series && this.formFields.sort.column == 'sEpisodesCount'){
        this.formFields.sort.column = 'sName';
      }
    },
    'formFields.id_vod_provider'(){
      if(this.skipEvent){
        this.skipEvent = false;
        return;
      }
      this.formFields.id_vod_package = 0;
      this.getVodPackageList()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodVideos/VodVideosListComponent.vue